import { loginRequest } from "./authConfig";
export async function getAccessToken(msal) {
    const result = await msal.instance.acquireTokenSilent(Object.assign(Object.assign({}, loginRequest), { account: msal.instance.getActiveAccount() || msal.instance.getAllAccounts()[0] }));
    return result.accessToken;
}
